import React from 'react';
import Box from '@mui/material/Box'
import { palette } from '../../themes/theme';
import { useAppSelector } from '../../redux/hooks';
import { selectCurrentLanguage } from '../../redux/selectors';
import Typography from '@mui/material/Typography';

import audioIcon from '../../assets/icons/audio.svg'
import bookIcon from '../../assets/icons/Vector_Book_2.svg'
import videoIcon from '../../assets/icons/video.svg'
import styles from './ButtonsGrid.module.css'

interface ButtonOption {
    active: number | boolean;
    action?: string;
    to: string;
    text: Record<string, string>;
}

interface ButtonsGridProps {
    options: ButtonOption[];
    setOption?: React.Dispatch<React.SetStateAction<string>>;
    toggleModal: React.Dispatch<React.SetStateAction<boolean>>;
    onWidgetSelect: (to: string) => void;
    currentWidget: string | null;
}

const colors = ['#55D4EF', '#90A5F0', '#CBAEE2']
const CHUNK_SIZE = 3;

const ButtonsGrid: React.FC<ButtonsGridProps> = ({ options, toggleModal, onWidgetSelect, currentWidget}) => {
    const language = useAppSelector(selectCurrentLanguage)

    const chunkArray = (array: ButtonOption[], chunkSize: number): ButtonOption[][] => {
        const result: ButtonOption[][] = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, (i+1) * chunkSize))
        }

        return result
    }

    const handleClick = (event: React.MouseEvent, action: string | undefined, to: string) => {
        if (action) {
            event.preventDefault()
            toggleModal(prev => !prev)
           
        }

        onWidgetSelect(to)
    }

    const rows = chunkArray(options, CHUNK_SIZE);

    return (
        <Box sx={{ flexGrow: 1, textAlign: 'center' }}>
            <Box className={styles['buttons-container']} sx={{
                display: 'flex',
                gap: '0.7rem',
                flexDirection: 'column',
            }}>
                <div className={`${styles.row} ${styles.logos}`}>
                    <div className={styles.logo} style={{height: '2.5rem', width: '2.5rem'}}>
                        <img src={videoIcon} alt='video icon'/>
                    </div>
                    <div className={styles.logo}>
                        <img src={audioIcon} alt='audio icon'/>
                    </div>
                    <div className={styles.logo}>
                        <img src={ bookIcon} alt='text icon'/>
                    </div>
                </div>
                {
                    rows.map((row, rowIndex) => {
                        return (
                            <div className={styles.row} key={rowIndex}>
                                {
                                    row.map((option, index) => {
                                        const color = colors[index % colors.length];
                                        const isSelected = currentWidget && currentWidget === option.to;
                                        return (
                                            <Box 
                                                component="button"
                                                key={`${rowIndex}_${index}`} 
                                                disabled={!option.active} 
                                                sx={{flex: 1, padding: 0, 
                                                width: '95px', 
                                                opacity: !option.active? '30%' : '',
                                                }}
                                                onClick={(e: React.MouseEvent) => handleClick(e, option.action, option.to) }
                                                > 
                                                {

                                                        <Typography variant='body1' component='div' color={!isSelected? 'white' : ''} lineHeight={'1.3rem'}                                                         sx={{
                                                            border: `1px solid ${color}`,
                                                            borderRadius: '3rem',
                                                            display: 'block',
                                                            height: '-webkit-fill-available',
                                                            alignContent: 'center',
                                                            padding: '0.5rem 0.5', 
                                                            pointerEvents: !option.active ? 'none' : undefined,
                                                            backgroundColor: isSelected ? palette.background.white : ''
                                                        }}>
                                                            {option.text[(language ?? 'en').replace('-', '')]}
                                                        </Typography>
                                                }
                                            </Box>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                    )
                }
            </Box>
        </Box>
    );
};

export default ButtonsGrid;
